/**
 * Contact ↔ Support form slide — ported from SeventyTwo 2026 Website.
 */
export function initContactSwap() {
    document.querySelectorAll('[data-contact-swap]').forEach(function (root) {
        var track = root.querySelector('[data-contact-track]');
        var contactPane = root.querySelector('[data-contact-pane="contact"]');
        var supportPane = root.querySelector('[data-contact-pane="support"]');

        if (!track || !contactPane || !supportPane) {
            return;
        }

        var swapButtons = root.querySelectorAll('[data-contact-swap-to]');

        var setMode = function (support) {
            root.classList.toggle('is-support', support);
            track.classList.toggle('is-support', support);

            contactPane.toggleAttribute('inert', support);
            supportPane.toggleAttribute('inert', !support);
            contactPane.setAttribute('aria-hidden', support ? 'true' : 'false');
            supportPane.setAttribute('aria-hidden', support ? 'false' : 'true');
            root.setAttribute(
                'aria-labelledby',
                support ? 'support-title' : 'contact-title'
            );

            swapButtons.forEach(function (btn) {
                var target = btn.getAttribute('data-contact-swap-to');
                var isActive =
                    (target === 'support' && support) ||
                    (target === 'contact' && !support);
                btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
            });

            if (support) {
                if (window.location.hash !== '#support') {
                    history.replaceState(null, '', '#support');
                }
            } else if (window.location.hash === '#support') {
                history.replaceState(
                    null,
                    '',
                    window.location.pathname + window.location.search
                );
            }
        };

        swapButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                setMode(btn.getAttribute('data-contact-swap-to') === 'support');
            });
        });

        setMode(window.location.hash === '#support');
    });
}
